import { render, staticRenderFns } from "./ClerkSelectInputWidget.vue?vue&type=template&id=18e98e3a&scoped=true"
import script from "./ClerkSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./ClerkSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e98e3a",
  null
  
)

export default component.exports